import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect, NavLink } from 'react-router-dom';
import { css } from 'glamor';

import galleries from 'core/images/galleries';
import Gallery from './components/Gallery';

const galleryIds = Object.keys(galleries).reverse();
const upperFirst = s => s[0].toUpperCase() + s.slice(1);

const activeGallery = css({
    backgroundColor: '#ccc',
    color: 'black',
    position: 'relative',
    ':hover': {
        backgroundColor: 'rgb(225,225,225)',
        color: 'black'
    },
    ':before': {
        content: "''",
        position: 'absolute',
        top: '0',
        left: '0',
        borderLeft: '7px solid #1b1b1b',
        borderBottom: '7px solid #ccc',
        width: '0'
    }
}).toString();

class Galleries extends React.Component {
    static propTypes = {
        match: PropTypes.shape({
            url: PropTypes.string.isRequired
        }).isRequired
    };

    render() {
        const redirect = <Redirect to={`${this.props.match.url}/${galleryIds[0]}`} />;

        return (
            <Switch>
                <Route
                    path={`${this.props.match.url}/:gallery`}
                    render={({ match }) => {
                        if (!galleries[match.params.gallery]) return redirect;

                        return (
                            <div className="sm-flex content-stretch">
                                <div
                                    className="sm-col sm-col-3 md-col md-col-2 lg-col lg-col-2"
                                    css={{ flexShrink: 0 }}
                                >
                                    {galleryIds.map(g => (
                                        <NavLink
                                            key={g}
                                            to={`${this.props.match.url}/${g}`}
                                            className="my1 block py1 pl2 mr2"
                                            activeClassName={activeGallery}
                                        >
                                            {upperFirst(g)}
                                        </NavLink>
                                    ))}

                                    {match.params.gallery === 'weddings' ? (
                                        <p className="pt2 pr2" css={{ fontSize: 11 }}>
                                            Some wedding images photographed on behalf of Complete
                                            Weddings, Manhattan, KS
                                        </p>
                                    ) : null}
                                </div>

                                <div className="sm-col-9 sm-col md-col md-col-10 lg-col lg-col-10 mb2">
                                    <Gallery images={galleries[match.params.gallery] || []} />
                                </div>
                            </div>
                        );
                    }}
                />
                {redirect}
            </Switch>
        );
    }
}

export default Galleries;



// WEBPACK FOOTER //
// ./src/pages/Galleries/index.js